import hotkeys from 'hotkeys-js';
import { deleteActiveObject, moveActiveObject } from '../../utils/active-object';

export default function Hotkeys(editor) {
    hotkeys('backspace', () => deleteActiveObject(editor));
    hotkeys('up, down, left, right', (_, handler) => moveActiveObject(editor, handler.key));
}